import { LanguageDropdown } from './language-dropdown';

export const LanguageDropdownControl = (props: {
  isLoading: boolean;
  onTranslate: (lang: string) => void;
}) => {
  return (
    <LanguageDropdown
      loading={props.isLoading}
      onSelectLanguage={props.onTranslate}
      variant="filled"
      color="default"
      placement="bottomRight"
    ></LanguageDropdown>
  );
};
